export class User {
  constructor(
      public userName: string,
      public emailId: string,
      public password: string,
      public confirmePassWord: string,
      public firstname: string,
      public lastname: string
  ) {}
}
